import { ArpMedia } from '@arpeggi/shared'
import { createContext, useContext } from 'react'

export const TableRowContext = createContext<ArpMedia>(null)

export const useMedia = () => useContext(TableRowContext)
